import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import BookingsTable from "@/features/bookings/bookings-table";

const bookingsSearchSchema = z.object({
  includeCancelled: fallback(z.boolean().optional(), undefined),
  page: fallback(z.number().optional(), undefined),
  pageSize: fallback(z.number().optional(), undefined),
});

export const Route = createFileRoute("/_app/(multi-location)/admin/bookings/")({
  component: Index,
  validateSearch: zodValidator(bookingsSearchSchema),
});

function Index() {
  const { includeCancelled } = Route.useSearch();

  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Bookinger</Trans>
        </h1>
      </Flex>

      <BookingsTable includeCancelled={includeCancelled} />
    </Box>
  );
}
